import { createStore } from "vuex";
import CartStore from "@Scripts/Stores/CartStore";
import CatalogueStore from "@Scripts/Stores/CatalogueStore";
import CookieToastStore from "@Scripts/Stores/CookieToastStore";

export const store = createStore({
    modules: {
        "cartStore": CartStore,
        "catalogueStore": CatalogueStore,
        "cookieToastStore": CookieToastStore
    }
});